import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import usePlanEndDateString from 'blocks/Pricing/usePlanEndDateString';
import DialogContent from 'components/DialogContent';
import CircularGradientGift from 'components/icons/circular-gradient/CircularGradientGift';
import { onShowFreeTrialModal } from 'redux/modules/mixpanel';
import { goToLocation } from 'redux/modules/router';
import { Dispatch } from 'redux/types';
import usePromotionDetails from './usePromotionDetails';

export interface FreeTrialWelcomeModalContentsProps {
  onHide?: () => void;
}

const FreeTrialWelcomeModalContents: React.FC<FreeTrialWelcomeModalContentsProps> = ({
  onHide,
}) => {
  const dispatch = useDispatch<Dispatch>();
  const expirationDateString = usePlanEndDateString();
  const details = usePromotionDetails();

  const { title, cta, redirectTo } = details;

  const handleClick = () => {
    if (redirectTo) {
      dispatch(goToLocation(redirectTo));
    }

    onHide();
  };

  useEffect(() => {
    dispatch(onShowFreeTrialModal('RUXWelcome'));
  }, [dispatch]);

  return (
    <DialogContent
      actions={[
        {
          children: cta,
          fluid: true,
          key: 'submit',
          onClick: handleClick,
          theme: 'rainbow',
        },
      ]}
      details={details.descriptionTemplate({
        expirationDate: expirationDateString,
      })}
      icon={<CircularGradientGift />}
      title={title}
    />
  );
};

export default FreeTrialWelcomeModalContents;
